<template>
  <div id="info_bar" class="vi-tabs">
    <div class="vi-tabs__inner">

      <!-- ══ Non-article path ══ -->
      <template v-if="!(item.main_category && item.main_category.id == 195)">

        <!-- Hero row: meta chips → big title → actions (mirrors vp-hero) -->
        <header class="vi-tabs__hero">
          <div class="vi-tabs__hero-head">
            <span class="vp-meta__pill vp-pill--accent">{{ typeLabel }}</span>
            <span v-if="item.year" class="vp-meta__chip">{{ item.year }}</span>
            <span v-if="item.main_category && item.main_category.name" class="vp-meta__chip">{{ item.main_category.name }}</span>
          </div>

          

          <div class="vi-tabs__actions">
            <label v-if="item.restricted === true" class="lbl_restricted">מוגבל</label>
              <h1 class="vi-tabs__title">{{ item.title }}</h1>
            <!-- <router-link
              :to="'/item/' + item.id"
              class="vi-tabs__play-link"
            >
              <button type="button" class="vi-action-btn vi-action-btn--primary">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M8 5v14l11-7z"/>
                </svg>
                הפעל
              </button>
            </router-link> -->

            <button
              v-if="item.restricted != true"
              type="button"
              class="vi-action-btn"
              :class="{ 'vi-action-btn--active': isFavorite }"
              @click="$emit('addToFav', item.id)"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" :fill="isFavorite ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
              {{ isFavorite ? 'הסר ממועדפים' : 'הוספה למועדפים' }}
            </button>
          </div>
        </header>

        <!-- Tab nav — pill style matching vp-season-tab -->
        <nav
          id="info_menu"
          class="vi-tabs__nav"
          role="tablist"
          aria-label="ניווט תוכן"
        >
          <button
            type="button"
            role="tab"
            :aria-selected="menuSelected === 'info' ? 'true' : 'false'"
            :class="['vi-tabs__tab', { 'vi-tabs__tab--active': menuSelected === 'info' }]"
            @click="$emit('update:menuSelected', 'info')"
          >
            סקירה כללית
          </button>
          <button
            v-if="item.type === 'series'"
            type="button"
            role="tab"
            :aria-selected="menuSelected === 'trailers' ? 'true' : 'false'"
            :class="['vi-tabs__tab', { 'vi-tabs__tab--active': menuSelected === 'trailers' }]"
            @click="$emit('update:menuSelected', 'trailers')"
          >
            {{ item.type === 'series' ? 'טריילרים ופרקים' : 'טריילר ועוד' }}
          </button>
        </nav>

        <!-- Panel: info -->
        <div
          v-if="menuSelected === 'info'"
          id="info_content_info"
          role="tabpanel"
          class="vi-tabs__panel"
        >
          <!-- Credit meta -->
          <div class="vi-tabs__meta">
            <span class="credit-section">
              קרדיט:
              <input
                :value="articleCredit"
                @input="$emit('update:articleCredit', $event.target.value)"
                @blur="$emit('saveCredit')"
                @keyup.enter="$emit('saveCredit')"
                class="credit-input"
                type="text"
                placeholder="פלאש 90"
              />
            </span>
          </div>

          <!-- Content sections with divider + eyebrow style -->
          <div v-if="item.full_description" class="vi-section">
            <h4 class="vi-section__eyebrow">תקציר</h4>
            <div class="vi-section__body">{{ item.full_description }}</div>
          </div>
          <div v-if="item.description && item.description !== ''" class="vi-section">
            <h4 class="vi-section__eyebrow">תיאור</h4>
            <div class="vi-section__body">{{ item.description }}</div>
          </div>
          <div v-if="item.content && item.content !== ''" class="vi-section">
            <h4 class="vi-section__eyebrow">תוכן</h4>
            <div class="vi-section__body">{{ item.content }}</div>
          </div>
          <div v-if="item.text && item.text !== ''" class="vi-section">
            <h4 class="vi-section__eyebrow">טקסט</h4>
            <div class="vi-section__body">{{ item.text }}</div>
          </div>
          <div v-if="item.actors && item.actors !== ''" class="vi-section">
            <h4 class="vi-section__eyebrow">שחקנים</h4>
            <div class="vi-section__body">{{ item.actors }}</div>
          </div>

          <!-- Related items — horizontal Splide carousel -->
          <section
            v-if="item.rel_items && item.rel_items.length"
            class="vi-related"
          >
            <div class="vi-related__header">
              <h3 class="vi-related__title">תוכן נוסף עבורך</h3>
            </div>
            <section ref="relSplide" class="splide vi-rail">
              <div class="splide__track">
                <ul class="splide__list">
                  <li
                    v-for="episodeItem in item.rel_items"
                    :key="episodeItem.id"
                    class="splide__slide"
                  >
                    <slot name="item-tpl" :item="episodeItem"></slot>
                  </li>
                </ul>
              </div>
            </section>
          </section>

          <div
            v-if="!item.rel_items || item.rel_items.length === 0"
            class="vi-tabs__empty"
            role="status"
          >
            <div class="vi-tabs__empty-icon" aria-hidden="true">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/></svg>
            </div>
            <p class="vi-tabs__empty-text">אין תוכן נוסף כרגע</p>
          </div>
        </div>

        <!-- Panel: episodes / trailers -->
        <div
          v-if="menuSelected === 'trailers'"
          id="episodes_bar"
          role="tabpanel"
          class="vi-tabs__panel"
        >
          <div class="episodes container" v-scroll-spy>
            <div v-for="season in seasons" :key="season.id" class="section">
              <h3 class="vi-tabs__season-title">עונה {{ season.num }}</h3>
              <div
                v-for="(episodeItem, index) in season.episodes"
                :key="episodeItem.id"
                class="episode"
                :class="{ active: episodeItem.id == episode.id }"
              >
                <svg
                  v-if="!isUserCanWatch"
                  width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  class="vi-tabs__lock-icon" aria-label="נעול" role="img"
                >
                  <template v-if="episodeItem.is_premium == 1">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </template>
                  <template v-else>
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 9.9-1"/>
                  </template>
                </svg>
                <router-link :to="'/item/' + item.id + '/' + episodeItem.id + '?is_episodes_bar_opened=false'">
                  <div class="pic" :style="'background-image:url(' + episodeItem.pic_thumb_parsed + ')'">
                    <div class="user_duration">
                      <span :style="'width:' + episodeItem.user_duration_perc + '%'"></span>
                    </div>
                  </div>
                  <div class="content">
                    <div v-if="episodeItem.video === ''" class="soon">בקרוב</div>
                    <h3>פרק {{ index + 1 }}</h3>
                    <h4>{{ episodeItem.title }}</h4>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>

      </template>

      <!-- ══ Article path (category 195) ══ -->
      <div v-if="item.main_category && item.main_category.id == 195" class="article-layout">
        <div v-if="item.pic_hero_parsed" class="article-image">
          <img :src="item.pic_hero_parsed" :alt="item.title" />
        </div>
        <div class="article-content">
          <div class="article-header">
            <div class="article-meta-chips">
              <span v-if="!isNull(item.main_category)" class="vp-meta__pill vp-pill--accent">{{ item.main_category.name }}</span>
              <span v-if="item.year" class="vp-meta__chip">{{ item.year }}</span>
            </div>
            <h1 class="article-title">{{ item.title }}</h1>
            <div class="article-meta">
              <span class="credit-section">
                קרדיט:
                <input
                  :value="articleCredit"
                  @input="$emit('update:articleCredit', $event.target.value)"
                  @blur="$emit('saveCredit')"
                  @keyup.enter="$emit('saveCredit')"
                  class="credit-input"
                  type="text"
                  placeholder="פלאש 90"
                />
              </span>
            </div>
          </div>
          <div class="article-body">
            <div v-if="item.description && item.description !== ''">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div class="content" v-html="item.description"></div>
            </div>
            <div v-if="item.content && item.content !== ''">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div class="content" v-html="item.content"></div>
            </div>
            <div v-if="item.text && item.text !== ''">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div class="content" v-html="item.text"></div>
            </div>
          </div>
        </div>

        <!-- Related articles grid -->
        <div
          v-if="relatedArticles && relatedArticles.length > 0"
          class="related-articles"
        >
          <div class="related-header vi-section-divider">
            <h2>תוכן מומלץ עבורך</h2>
          </div>
          <div class="articles-grid">
            <button
              v-for="article in relatedArticles"
              :key="article.id"
              type="button"
              class="article-card"
              @click="$emit('goToArticle', article.id)"
            >
              <div class="article-card__image">
                <img
                  v-if="article.pic_hero_parsed"
                  :src="article.pic_hero_parsed"
                  :alt="article.title"
                  loading="lazy"
                />
                <div v-else class="no-image" aria-hidden="true">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
                    <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
                  </svg>
                </div>
              </div>
              <div class="article-card__info">
                <div class="article-card__meta">
                  <span v-if="article.main_category" class="vp-meta__chip vp-meta__chip--sm">{{ article.main_category.name }}</span>
                  <span v-if="article.year" class="vp-meta__chip vp-meta__chip--sm">{{ article.year }}</span>
                </div>
                <h3 class="article-card__title">{{ article.title }}</h3>
                <div v-if="article.description" class="article-card__excerpt">
                  {{ truncateText(article.description, 120) }}
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>

    </div><!-- /.vi-tabs__inner -->
  </div>
</template>

<script>
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

const REL_SPLIDE_OPTS = {
  type: 'loop',
  direction: 'rtl',
  perPage: 5,
  perMove: 5,
  gap: '6px',
  pagination: false,
  arrows: true,
  drag: true,
  speed: 600,
  breakpoints: {
    1280: { perPage: 4, perMove: 4 },
    1024: { perPage: 3, perMove: 3 },
    768:  { perPage: 3, perMove: 3 },
    640:  { perPage: 2, perMove: 2 },
  },
};

export default {
  name: 'VideoInfoTabs',
  props: {
    item: { type: Object, default: () => ({}) },
    seasons: { type: Array, default: () => [] },
    episode: { type: Object, default: () => ({}) },
    menuSelected: { type: String, default: 'info' },
    isUserCanWatch: { type: Boolean, default: false },
    articleCredit: { type: String, default: '' },
    relatedArticles: { type: Array, default: () => [] },
    isFavorite: { type: Boolean, default: false },
  },
  data() {
    return {
      relSplide: null,
    };
  },
  computed: {
    typeLabel() {
      if (this.item.type === 'live') return 'שידור חי';
      if (this.item.type === 'series') return 'סדרה';
      return 'סרט';
    },
  },
  watch: {
    menuSelected(val) {
      if (val === 'info') {
        this.$nextTick(() => this.initRelSplide());
      }
    },
    'item.rel_items'(val) {
      if (val && val.length) {
        this.$nextTick(() => this.initRelSplide());
      }
    },
  },
  mounted() {
    this.$nextTick(() => this.initRelSplide());
  },
  beforeDestroy() {
    if (this.relSplide) {
      try { this.relSplide.destroy(true); } catch (e) { /* noop */ }
    }
  },
  methods: {
    isNull(val) {
      return val === null || val === undefined;
    },
    truncateText(text, maxLength) {
      if (!text) return '';
      const plainText = text.replace(/<[^>]*>/g, '');
      if (plainText.length <= maxLength) return plainText;
      return plainText.substring(0, maxLength) + '...';
    },
    initRelSplide() {
      if (this.relSplide) {
        try { this.relSplide.destroy(true); } catch (e) { /* noop */ }
        this.relSplide = null;
      }
      var el = this.$refs.relSplide;
      if (!el) return;
      try {
        this.relSplide = new Splide(el, REL_SPLIDE_OPTS).mount();
      } catch (e) {
        /* noop */
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* ── Shell wrapper ── */
.vi-tabs {
  background: var(--color-bg);
}

.vi-tabs__inner {
  max-width: 1200px;
  margin-inline: auto;
  padding: var(--space-8) var(--space-6) var(--space-16);
}

@media only screen and (max-width: 768px) {
  .vi-tabs__inner {
    padding: var(--space-5) var(--space-4) var(--space-12);
  }
}

/* ── Hero row (non-article) ── */
.vi-tabs__hero {
  margin-block-end: var(--space-8);
}

.vi-tabs__hero-head {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-wrap: wrap;
  margin-block-end: var(--space-3);
}

/* Chip/pill tokens (mirror videoPage) */
.vp-meta__pill {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: var(--color-text);
  padding: 3px 10px;
  border-radius: 4px;
  font-family: var(--font-hebrew);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.vp-pill--accent {
  background: linear-gradient(135deg, var(--color-accent), var(--color-accentHover, var(--color-accent)));
  border-color: transparent;
  color: #fff;
  box-shadow: 0 2px 8px rgba(225, 29, 42, 0.35);
}

.vp-meta__chip {
  display: inline-flex;
  align-items: center;
  font-family: var(--font-hebrew);
  font-size: 13px;
  font-weight: 500;
  color: var(--color-textMuted);
  padding: 2px 10px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 4px;
}

.vp-meta__chip--sm {
  font-size: 11px;
  padding: 1px 8px;
}

/* ── Title ── */
.vi-tabs__title {
  font-family: var(--font-hebrew);
  font-size: 42px;
  font-weight: 800;
  color: var(--color-text);
  margin: 0 0 var(--space-5);
  line-height: 1.15;
  letter-spacing: -0.75px;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
}

/* ── Action buttons ── */
.vi-tabs__actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  align-items: center;
  justify-content: space-between;
}

.vi-tabs__play-link {
  text-decoration: none;
}

.vi-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  height: 48px;
  padding-inline: var(--space-6);
  background: var(--color-surface3);
  color: var(--color-text);
  border: 1px solid var(--color-borderHi, var(--color-border));
  border-radius: var(--radius-sm);
  font-family: var(--font-hebrew);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 150ms ease, transform 150ms ease;
}

.vi-action-btn:hover {
  background: var(--color-surface4);
}

.vi-action-btn:active {
  transform: translateY(1px);
}

.vi-action-btn:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.vi-action-btn--primary {
  background: var(--color-accent);
  color: #fff;
  border-color: var(--color-accent);
  padding-inline: var(--space-7);
}

.vi-action-btn--primary:hover {
  background: var(--color-accentHover);
}

.vi-action-btn--primary:active {
  background: var(--color-accentPress);
}

.vi-action-btn--active {
  background: rgba(255, 193, 7, 0.15);
  border-color: rgba(255, 193, 7, 0.5);
  color: #ffc107;
}

.vi-action-btn--active:hover {
  background: rgba(255, 193, 7, 0.25);
}

/* ── Tab nav — pill style ── */
.vi-tabs__nav {
  display: flex;
  gap: var(--space-2);
  margin-block-end: var(--space-8);
  flex-wrap: wrap;
}

.vi-tabs__tab {
  height: 36px;
  padding-inline: var(--space-4);
  background: var(--color-surface3);
  color: var(--color-textMuted);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-pill);
  font-family: var(--font-hebrew);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 150ms ease, color 150ms ease, border-color 150ms ease;
}

.vi-tabs__tab:hover {
  background: var(--color-surface4);
  color: var(--color-text);
}

.vi-tabs__tab--active {
  background: var(--color-accent);
  color: #fff;
  border-color: var(--color-accent);
}

.vi-tabs__tab:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

/* ── Panel ── */
.vi-tabs__panel {
  color: var(--color-text);
}

/* ── Meta credit row ── */
.vi-tabs__meta {
  margin-block-end: var(--space-6);
  color: var(--color-textMuted);
  font-size: 14px;
}

/* ── Content sections with eyebrow ── */
.vi-section {
  border-block-start: 1px solid var(--color-border);
  padding-block-start: var(--space-6);
  margin-block-end: var(--space-6);
}

.vi-section__eyebrow {
  font-family: var(--font-hebrew);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--color-textMuted);
  margin: 0 0 var(--space-3);
}

.vi-section__body {
  font-family: var(--font-hebrew);
  font-size: 17px;
  line-height: 1.7;
  color: var(--color-text);
  opacity: 0.85;
}

/* ── Related rail ── */
.vi-related {
  border-block-start: 1px solid var(--color-border);
  padding-block-start: var(--space-6);
  margin-block-start: var(--space-8);
}

.vi-related__header {
  margin-block-end: var(--space-4);
}

.vi-related__title {
  font-family: var(--font-hebrew);
  font-size: 22px;
  font-weight: 700;
  color: var(--color-text);
  margin: 0;
  letter-spacing: -0.2px;
}

/* Splide rail (same overrides as videoPage) */
.vi-rail {
  padding: 0;
}

.vi-rail :deep(.splide__track) { overflow: hidden; }
.vi-rail :deep(.splide__list)  { align-items: stretch; }
.vi-rail :deep(.splide__slide) { display: flex; }
.vi-rail :deep(.poster-card)   { width: 100%; }
.vi-rail :deep(.poster-card__inner) { width: 100%; max-width: none; min-width: 0; }

.vi-rail :deep(.splide__arrows) { pointer-events: none; }
.vi-rail :deep(.splide__arrow) {
  pointer-events: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 48px;
  height: auto;
  transform: none;
  border: none;
  border-radius: 0;
  cursor: pointer;
  z-index: 20;
  opacity: 0.85;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 180ms ease, background 180ms ease;
}
.vi-rail :deep(.splide__arrow svg) { width: 22px; height: 22px; fill: #fff; }
.vi-rail :deep(.splide__arrow--prev) {
  right: 0; left: auto;
  background: linear-gradient(to left, rgba(0, 0, 0, 0.65) 20%, transparent 100%);
}
.vi-rail :deep(.splide__arrow--next) {
  left: 0; right: auto;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.65) 20%, transparent 100%);
}
.vi-rail :deep(.splide__arrow:hover) { opacity: 1; }
.vi-rail :deep(.splide__arrow:disabled) { opacity: 0; }

@media (hover: none) {
  .vi-rail :deep(.splide__arrow) { display: none; }
}

/* ── Season / episode ── */
.vi-tabs__season-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--color-text);
  margin-block-end: var(--space-3);
  font-family: var(--font-hebrew);
}

.vi-tabs__lock-icon {
  color: var(--color-textMuted);
  margin-inline-end: var(--space-2);
}

/* ── Empty state ── */
.vi-tabs__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-12) var(--space-6);
  background: var(--color-surface1);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  gap: var(--space-4);
  text-align: center;
}

.vi-tabs__empty-icon {
  inline-size: 64px;
  block-size: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface3);
  border-radius: var(--radius-md);
  color: var(--color-textMuted);
}

.vi-tabs__empty-text {
  font-size: 14px;
  color: var(--color-textMuted);
  margin: 0;
}

/* ── Credit input ── */
.credit-section {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
}

.credit-input {
  background: transparent;
  border: none;
  border-block-end: 1px solid rgba(255, 255, 255, 0.3);
  color: var(--color-textMuted);
  padding: 2px 4px;
  font-size: 14px;
  font-family: var(--font-hebrew);
  min-inline-size: 100px;
  max-inline-size: 200px;
  outline: none;
  transition: border-color var(--duration-fast) var(--easing-default);
}

.credit-input:focus {
  border-block-end-color: var(--color-accent);
}

.credit-input::placeholder {
  color: var(--color-textDim);
}

/* ══════════════════════════════════════════════════
   ARTICLE LAYOUT (category 195)
══════════════════════════════════════════════════ */

.article-image img {
  inline-size: 100%;
  max-inline-size: 860px;
  border-radius: var(--radius-md);
  margin-block-end: var(--space-8);
}

.article-meta-chips {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-wrap: wrap;
  margin-block-end: var(--space-4);
}

.article-title {
  font-family: var(--font-hebrew);
  font-size: 40px;
  font-weight: 800;
  color: var(--color-text);
  line-height: 1.2;
  letter-spacing: -0.5px;
  margin: 0 0 var(--space-4);
}

.article-meta {
  color: var(--color-textMuted);
  font-size: 14px;
  margin-block-end: var(--space-8);
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.article-content {
  max-inline-size: 760px;
}

.article-body .content {
  font-family: var(--font-hebrew);
  font-size: 18px;
  line-height: 1.7;
  color: var(--color-text);
  opacity: 0.9;
  text-align: start;
  direction: rtl;
}

/* ── Related articles grid ── */
.related-articles {
  margin-block-start: var(--space-12);
}

.vi-section-divider {
  border-block-start: 1px solid var(--color-border);
  padding-block-start: var(--space-8);
  margin-block-end: var(--space-8);
}

.related-header h2 {
  font-family: var(--font-hebrew);
  font-size: 28px;
  font-weight: 700;
  color: var(--color-text);
  margin: 0;
  letter-spacing: -0.3px;
}

.articles-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-6);
}

@media only screen and (max-width: 900px) {
  .articles-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media only screen and (max-width: 580px) {
  .articles-grid {
    grid-template-columns: 1fr;
  }
}

.article-card {
  background: var(--color-surface2);
  border-radius: var(--radius-md);
  overflow: hidden;
  cursor: pointer;
  transition: transform var(--duration-slow) var(--easing-default),
              box-shadow var(--duration-slow) var(--easing-default),
              border-color var(--duration-slow) var(--easing-default);
  border: 1px solid var(--color-border);
  text-align: start;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.article-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-md);
  border-color: var(--color-borderHi);
}

.article-card:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.article-card__image {
  position: relative;
  block-size: 200px;
  overflow: hidden;
  flex-shrink: 0;
}

.article-card__image img {
  inline-size: 100%;
  block-size: 100%;
  object-fit: cover;
  transition: transform var(--duration-slow) var(--easing-default);
}

.article-card:hover .article-card__image img {
  transform: scale(1.06);
}

.article-card .no-image {
  block-size: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface3);
  color: var(--color-textDim);
}

.article-card__info {
  padding: var(--space-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  flex: 1;
}

.article-card__meta {
  display: flex;
  gap: var(--space-2);
  flex-wrap: wrap;
}

.article-card__title {
  font-family: var(--font-hebrew);
  font-size: 18px;
  font-weight: 700;
  color: var(--color-text);
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.article-card__excerpt {
  font-size: 13px;
  color: var(--color-textMuted);
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ── Mobile adjustments ── */
@media only screen and (max-width: 768px) {
  .vi-tabs__title { font-size: 26px; }
  .article-title { font-size: 28px; }
  .vi-rail :deep(.splide__arrow) { display: none; }
}

/* ── Reduced motion ── */
@media (prefers-reduced-motion: reduce) {
  .vi-tabs__tab,
  .vi-action-btn,
  .article-card,
  .article-card__image img,
  .credit-input,
  .vi-rail :deep(.splide__arrow) {
    transition: none;
  }
}
</style>
